var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTileFlooring(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5461_16674)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1248 16.5428H19.8638V30.3254H14.1248V16.5428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9578 24.6018V30.3426H22.1392V24.6018H35.9578Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.07275 14.2726V8.50272H19.8605V14.2726H6.07275Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8988 6.22563H14.1094V0.459167H27.8988V6.22563Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9424 14.2709H30.1982V0.486603H35.9424V14.2709Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1667 8.50787H27.8835V22.311H22.1667V8.50787Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.950928 22.3728V16.5428H11.8803V20.8158C11.8803 22.359 11.8803 22.359 10.3525 22.359H0.950928V22.3728Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.04858 35.4317V24.5333H7.22485C8.56744 24.5333 9.90832 24.5127 11.2492 24.5555C11.4635 24.5555 11.8511 24.847 11.8528 25.0082C11.8871 28.4564 11.8785 31.9064 11.8785 35.4317H6.04858Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.77496 14.2692H0.962891V0.493469H3.77496V14.2692Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.106 35.4592V32.6299H27.8834V35.4592H14.106Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06592 0.457458H11.8084V6.2102H6.06592V0.457458Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2119 16.5566H35.9424V22.3162H30.2119V16.5566Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.962891 24.5813H3.77496V30.3254H0.962891V24.5813Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2 32.6231H35.9424V35.4386H30.2V32.6231Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.962891 35.4283V32.6265H3.77325V35.4283H0.962891Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5461_16674"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.0069,
    height: 35,
    fill: "white",
    transform: "translate(0.950928 0.457458)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileFlooring);
export default __webpack_public_path__ + "static/media/tile-flooring.fadb30b4086c8d40209ce38788bece28.svg";
export { ForwardRef as ReactComponent };